<app-header [showBackButton]="false" currentTitle="Forgot Password"></app-header>

<div class="forgot-password-container">
    <mat-stepper orientation="vertical" linear="true" #stepper>
        <mat-step [stepControl]="accountDetailsFormGroup">
            <form [formGroup]="accountDetailsFormGroup">
                <ng-template matStepLabel>Account details</ng-template>
                <p>
                    <mat-form-field class="forgot-password-input-width">
                        <mat-label>Email</mat-label>
                        <input matInput placeholder="Email" formControlName="emailCtrl" required type="email">
                    </mat-form-field>
                </p>
                <div>
                    <button mat-raised-button color="primary" (click)="onVerify(stepper)" [disabled]="!accountDetailsFormGroup.valid">Verify</button>
                </div>
            </form>
        </mat-step>
        <mat-step [stepControl]="verificationFormGroup">
            <form [formGroup]="verificationFormGroup">
                <ng-template matStepLabel>Verification code</ng-template>
                <p>
                    <mat-form-field class="forgot-password-input-width">
                        <mat-label>Verification Code</mat-label>
                        <input matInput placeholder="Code" formControlName="codeCtrl" required type="text">
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field class="forgot-password-input-width">
                        <mat-label>New Password</mat-label>
                        <input matInput placeholder="New Password" formControlName="newPasswordCtrl" required type="password">
                    </mat-form-field>
                </p>
                <div>
                    <button mat-raised-button color="primary" (click)="onComplete(stepper)">Change Password</button>
                </div>
            </form>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>Done</ng-template>
            <p>Password reset complete, click Done to return to the login page.</p>
            <div>
              <button mat-button (click)="onDone()">Done</button>
            </div>
        </mat-step>
    </mat-stepper>
</div>